import { SupplierEmailsEditor } from "./SupplierEmailsEditor";
import { supplierEmails, useSuppliers } from "./useSuppliers";

const fieldStyle = {
    width: "100%",
    border: "1px solid #cbd5e1",
    borderRadius: "7px",
    padding: "8px 10px",
    fontSize: "13px",
    color: "#0f172a",
    background: "white",
    boxSizing: "border-box",
};
const labelStyle = { fontSize: "12px", fontWeight: 700, color: "#475569", marginBottom: "5px" };

function SupplierForm({ form, setForm, editingId, saving, error, submit, resetForm }) {
    return (
        <form onSubmit={submit} style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "16px", display: "flex", flexDirection: "column", gap: "12px" }}>
            <div>
                <div style={{ fontSize: "15px", fontWeight: 800, color: "#0f172a" }}>
                    {editingId ? "Modifier le fournisseur" : "Ajouter un fournisseur"}
                </div>
            </div>
            <div>
                <div style={labelStyle}>Nom</div>
                <input
                    style={fieldStyle}
                    value={form.name}
                    onChange={e => setForm(prev => ({ ...prev, name: e.target.value }))}
                    required
                    placeholder="Alcura, Orkyn..."
                />
            </div>
            <SupplierEmailsEditor
                emails={form.emails}
                onChange={emails => setForm(prev => ({ ...prev, emails, email: emails[0] || "" }))}
                fieldStyle={fieldStyle}
            />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                <div>
                    <div style={labelStyle}>Téléphone</div>
                    <input style={fieldStyle} value={form.phone} onChange={e => setForm(prev => ({ ...prev, phone: e.target.value }))} />
                </div>
                <div>
                    <div style={labelStyle}>Contact</div>
                    <input style={fieldStyle} value={form.contactName} onChange={e => setForm(prev => ({ ...prev, contactName: e.target.value }))} />
                </div>
            </div>
            <div>
                <div style={labelStyle}>Adresse</div>
                <input style={fieldStyle} value={form.address} onChange={e => setForm(prev => ({ ...prev, address: e.target.value }))} />
            </div>
            <div>
                <div style={labelStyle}>Notes</div>
                <textarea
                    style={{ ...fieldStyle, minHeight: "86px", resize: "vertical" }}
                    value={form.notes}
                    onChange={e => setForm(prev => ({ ...prev, notes: e.target.value }))}
                />
            </div>
            {error && <div style={{ fontSize: "12px", color: "#dc2626", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "7px", padding: "8px 10px" }}>{error}</div>}
            <div style={{ display: "flex", gap: "8px" }}>
                <button type="submit" disabled={saving} style={{ padding: "9px 14px", borderRadius: "7px", border: 0, background: saving ? "#93c5fd" : "#2563eb", color: "white", fontWeight: 700, cursor: saving ? "default" : "pointer" }}>
                    {saving ? "Enregistrement..." : "Enregistrer"}
                </button>
                {editingId && (
                    <button type="button" onClick={resetForm} style={{ padding: "9px 14px", borderRadius: "7px", border: "1px solid #cbd5e1", background: "white", color: "#475569", fontWeight: 700, cursor: "pointer" }}>
                        Annuler
                    </button>
                )}
            </div>
        </form>
    );
}

function SupplierRows({ suppliers, loading, refresh, edit, remove }) {
    return (
        <div style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: "8px", overflow: "hidden" }}>
            <div style={{ padding: "12px 14px", borderBottom: "1px solid #e2e8f0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ fontSize: "15px", fontWeight: 800, color: "#0f172a" }}>Fournisseurs</div>
                <button type="button" onClick={refresh} style={{ padding: "6px 10px", borderRadius: "7px", border: "1px solid #cbd5e1", background: "white", color: "#475569", cursor: "pointer", fontWeight: 600 }}>
                    Actualiser
                </button>
            </div>
            {loading ? (
                <div style={{ padding: "18px", color: "#64748b", fontSize: "13px" }}>Chargement...</div>
            ) : suppliers.length === 0 ? (
                <div style={{ padding: "18px", color: "#64748b", fontSize: "13px" }}>Aucun fournisseur enregistré.</div>
            ) : (
                <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                        <thead>
                            <tr style={{ background: "#f8fafc", color: "#475569", textAlign: "left" }}>
                                <th style={{ padding: "10px 12px", borderBottom: "1px solid #e2e8f0" }}>Nom</th>
                                <th style={{ padding: "10px 12px", borderBottom: "1px solid #e2e8f0" }}>Mails</th>
                                <th style={{ padding: "10px 12px", borderBottom: "1px solid #e2e8f0" }}>Téléphone</th>
                                <th style={{ padding: "10px 12px", borderBottom: "1px solid #e2e8f0" }}>Contact</th>
                                <th style={{ padding: "10px 12px", borderBottom: "1px solid #e2e8f0", width: "150px" }} />
                            </tr>
                        </thead>
                        <tbody>
                            {suppliers.map(supplier => (
                                <tr key={supplier.id}>
                                    <td style={{ padding: "11px 12px", borderBottom: "1px solid #f1f5f9", fontWeight: 700, color: "#0f172a" }}>{supplier.name}</td>
                                    <td style={{ padding: "11px 12px", borderBottom: "1px solid #f1f5f9", color: "#475569" }}>
                                        {supplierEmails(supplier).length === 0 ? "—" : (
                                            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                                {supplierEmails(supplier).map(email => (
                                                    <span key={email}>{email}</span>
                                                ))}
                                            </div>
                                        )}
                                    </td>
                                    <td style={{ padding: "11px 12px", borderBottom: "1px solid #f1f5f9", color: "#475569" }}>{supplier.phone || "—"}</td>
                                    <td style={{ padding: "11px 12px", borderBottom: "1px solid #f1f5f9", color: "#475569" }}>{supplier.contactName || "—"}</td>
                                    <td style={{ padding: "8px 12px", borderBottom: "1px solid #f1f5f9", display: "flex", gap: "6px", justifyContent: "flex-end" }}>
                                        <button type="button" onClick={() => edit(supplier)} style={{ padding: "6px 10px", borderRadius: "6px", border: "1px solid #bfdbfe", background: "#eff6ff", color: "#1d4ed8", cursor: "pointer", fontWeight: 600 }}>Modifier</button>
                                        <button type="button" onClick={() => remove(supplier)} style={{ padding: "6px 10px", borderRadius: "6px", border: "1px solid #fecaca", background: "#fef2f2", color: "#dc2626", cursor: "pointer", fontWeight: 600 }}>Supprimer</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

// Fournisseurs du service : formulaire à gauche, liste à droite.
export function SupplierTable({ serviceKey }) {
    const suppliers = useSuppliers(serviceKey);
    return (
        <div style={{ height: "100%", overflow: "auto", background: "#f8fafc" }}>
            <div style={{ padding: "18px", display: "grid", gridTemplateColumns: "minmax(320px, 420px) 1fr", gap: "18px", alignItems: "start" }}>
                <SupplierForm {...suppliers} />
                <SupplierRows {...suppliers} />
            </div>
        </div>
    );
}
